import { LOADER_ACTIONS } from '../constants';

export const setPostInitLoaderActive = () => {
	return {
		type: LOADER_ACTIONS.set_loader_active,
	};
};

export const setPostInitLoaderInactive = () => ({
	type: LOADER_ACTIONS.set_loader_inactive,
});
